<template>
  <va-dropdown
    class="profile-dropdown"
    v-model="isShown"
    boundary-body
    offset="0, 16px"
  >
    <span
      class="profile-dropdown__anchor" slot="anchor"
      :style="{color: this.$themes.primary}"
    >
      <slot/>
      <va-icon
        class="pa-1"
        :name="`fa ${isShown ? 'fa-angle-up' :'fa-angle-down'}`"
      />
    </span>
    <div class="profile-dropdown__content px-2 py-2">

      <p class="profile-dropdown__item" @click="signout">
        Выйти
      </p>
      <!-- <router-link
        v-for="option in options"
        :key="option.name"
        :to="{name: option.redirectTo}"
        class=""
      >
        {{ $t(`user.${option.name}`) }}
      </router-link> -->
    </div>
  </va-dropdown>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  name: 'profile-section',
  data () {
    return {
      isShown: false,
    }
  },
  props: {
    options: {
      type: Array,
      default: () => [
        {
          name: 'profile',
          redirectTo: '',
        },
        {
          name: 'logout',
          redirectTo: 'login',
        },
      ],
    },
  },
  methods: {
    ...mapMutations('auth', ['RESET_ALL']),
    signout () {
      this.RESET_ALL('RESET_ALL')
      if (this.$route.name !== 'login') {
        this.$router.push({ name: 'login' })
      }
    },
  },
}
</script>

<style lang="scss">

.profile-dropdown {
  cursor: pointer;

  &__anchor {
    color: $vue-green;
  }

  .va-dropdown-popper__anchor {
    display: flex;
    justify-content: flex-end;
  }

  &__content {
    background-color: $dropdown-background;
    box-shadow: $gray-box-shadow;
    border-radius: 0.5rem;
    width: 8rem;
  }

  &__item {
    display: block;
    color: $vue-darkest-blue;

    &:hover,
    &:active {
      color: $vue-green;
    }
  }

  .va-dropdown__anchor {
    display: inline-block;
  }
}
</style>
